export default {
  "base": "rounded-full"
}